export default __webpack_public_path__ + "static/media/defient-stack2.webp";